import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuthFetch } from '../hooks/useAuthFetch';
import '../stili/AllenamentiStaff.css';

const API_URL = process.env.REACT_APP_API_URL;

const oggiIso = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const formatOra = (val) => {
  if (!val) return '';
  return String(val).slice(0, 5);
};

const formatDataIt = (dataIso) => {
  if (!dataIso) return '';
  const [y, m, d] = dataIso.split('-');
  return `${d}/${m}/${y}`;
};

const renderTestoFase = (value) => {
  return value?.trim() ? value : '-';
};

const formatDataFileIt = (dataIso) => {
  if (!dataIso) return '';
  const [y, m, d] = dataIso.split('-');
  return `${d}-${m}-${y}`;
};

export default function AllenamentiStaff() {
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const [data, setData] = useState(oggiIso());
  const [allenamenti, setAllenamenti] = useState([]);
  const [loading, setLoading] = useState(false);

  const titoloPagina = useMemo(() => {
    return `Allenamenti del ${formatDataIt(data)}`;
  }, [data]);

  const parseErrorMessage = async (res, fallbackMessage) => {
    try {
      const contentType = res.headers.get('content-type') || '';

      if (contentType.includes('application/json')) {
        const err = await res.json();
        return err?.message || err?.error || err?.details || fallbackMessage;
      }

      const txt = await res.text();
      return txt || fallbackMessage;
    } catch {
      return fallbackMessage;
    }
  };

  const fetchAllenamenti = async () => {
    setLoading(true);

    try {
      const res = await authFetch(
        `${API_URL}/api/allenamenti/miei?data=${data}`
      );

      if (!res.ok) {
        throw new Error(
          await parseErrorMessage(res, 'Errore nel caricamento degli allenamenti')
        );
      }

      const result = await res.json();
      setAllenamenti(Array.isArray(result) ? result : []);
    } catch (err) {
      setAllenamenti([]);
      toast.error(err.message || 'Errore nel caricamento degli allenamenti');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllenamenti();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handlePdf = async () => {
  try {
    const res = await authFetch(
      `${API_URL}/api/allenamenti/miei/pdf?data=${data}`
    );

    if (!res.ok) {
      throw new Error(
        await parseErrorMessage(res, 'Errore nella generazione del PDF')
      );
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `programma_allenamenti_${formatDataFileIt(data)}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    toast.error(err.message || 'Errore nella generazione del PDF');
  }
};

  return (
    <div className="allenamenti-staff-container">
      <div className="allenamenti-staff-header">
        <h2>I miei allenamenti</h2>

        <div className="allenamenti-staff-toolbar">
          <div className="allenamenti-staff-filter">
            <label htmlFor="dataAllenamenti">Data</label>
            <input
              id="dataAllenamenti"
              type="date"
              value={data}
              onChange={(e) => setData(e.target.value)}
            />
          </div>

          <div className="allenamenti-staff-actions">
            <button
              type="button"
              className="btn-allenamenti aggiorna"
              onClick={fetchAllenamenti}
              disabled={loading}
            >
              {loading ? 'Caricamento...' : 'Aggiorna'}
            </button>

            <button
              type="button"
              className="btn-allenamenti stampa"
              onClick={handlePdf}
              disabled={loading}
            >
              Genera PDF
            </button>
          </div>
        </div>
      </div>

      <div className="allenamenti-staff-card">
        <div className="allenamenti-staff-title">
          <h3>{titoloPagina}</h3>
          <span>{allenamenti.length} allenamento/i</span>
        </div>

        {loading ? (
          <div className="allenamenti-staff-empty">Caricamento in corso...</div>
        ) : allenamenti.length === 0 ? (
          <div className="allenamenti-staff-empty">
            Nessun allenamento trovato per la data selezionata.
          </div>
        ) : (
          <div className="allenamenti-staff-list">
            {allenamenti.map((a) => (
              <div key={a.id} className="allenamento-staff-item">
                <table className="allenamenti-staff-table">
                  <thead>
                    <tr>
                      <th>Ora Inizio</th>
                      <th>Ora Fine</th>
                      <th>Categoria</th>
                      <th>Campo</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{formatOra(a.oraInizio) || '-'}</td>
                      <td>{formatOra(a.oraFine) || '-'}</td>
                      <td>{a.nomeCategoria || '-'}</td>
                      <td>{a.campo || '-'}</td>
                      <td>{a.tipoAllenamento || '-'}</td>
                    </tr>
                  </tbody>
                </table>

                <div className="allenamento-fasi-staff">
                  <div className="allenamento-fase-staff-box">
                    <strong>
                      1 Fase di attivazione
                      {a.durataAttivazione ? ` (${a.durataAttivazione} min)` : ''}
                    </strong>
                    <div>{renderTestoFase(a.faseAttivazione)}</div>
                  </div>

                  <div className="allenamento-fase-staff-box">
                    <strong>
                      2 Fase centrale
                      {a.durataCentrale ? ` (${a.durataCentrale} min)` : ''}
                    </strong>
                    <div>{renderTestoFase(a.faseCentrale)}</div>
                  </div>

                  <div className="allenamento-fase-staff-box">
                    <strong>
                      3 Fase finale
                      {a.durataFinale ? ` (${a.durataFinale} min)` : ''}
                    </strong>
                    <div>{renderTestoFase(a.faseFinale)}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="allenamenti-staff-back">
        <button
          className="allenamento-custom-button"
          type="button"
          onClick={() => navigate('/gestionale')}
        >
          Torna al Gestionale
        </button>
      </div>
    </div>
  );
}